module.exports = __webpack_public_path__ + "img/BioSmartex.ede9b4d2.webp";